import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { adminBaseUrl } from "../routes";
import { approveMsg, getAllMessages, getImages, sendMessage } from "./queries";
import { headerWithAuthToken } from "../headers";

const chatsApi = createApi({
  reducerPath: "chatsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: adminBaseUrl,
    prepareHeaders: headerWithAuthToken,
  }),
  endpoints: (builder) => ({
    //get all messages
    getAllMessages: builder.query({
      providesTags: ["all_messages"],
      query: getAllMessages,
    }),

    //send message
    sendMessage: builder.mutation({
      invalidatesTags: ["send_message"],
      query: sendMessage,
    }),

    //get images
    getImages: builder.query({
      providesTags: ["all_images"],
      query: getImages,
    }),

    approveMsg: builder.mutation({
      invalidatesTags: ["all_messages"],
      query: approveMsg
    })
  }),
});

export const {
  useGetAllMessagesQuery,
  useSendMessageMutation,
  useGetImagesQuery,
  useApproveMsgMutation,
  reducer: chatsApiReducer,
  reducerPath: chatsApiReducerPath,
  middleware: chatsApiMiddleware,
} = chatsApi;
